import React, { useState, useEffect, useRef } from "react";
import { Button, Modal } from "react-bootstrap";
import InputField from "../../jsx/components/fields/inputField";
import JoinAsField from "../../jsx/components/fields/joinAsField";
import PrimaryButton from "../../jsx/components/button/primaryButton";
import SearchAddressInput from "../../jsx/components/fields/searchAddressInput";
import Avatar from "../../jsx/components/fields/avatar";
import profileAv from "../../icons/photos/profileAvatar.png";
import filter from "../../icons/photos/filter.svg";
import "./particularUserDetailsForAdmin.scss";
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { userById } from '../../service/api/user/userById'
import { firstNameValidation } from '../../functions/validations'
import updateUserApi from '../../service/api/user/updateUserDetails';
import { searchAddress } from '../../service/api/user/searchAddress';
import deleteUser from '../../service/api/user/deleteUserById';
import { signout } from '../../feature/authSlice';
import InternationalPhoneFormatFun from '../../ui/InternationalPhoneFormatFun';
import { lblAddress, lblEmail, lblFirstName, lblLastName, lblPhoneNumber, txtRole, txtUserDetails, txtUserName } from "../../dataBaseFile/label";
import { validFirstName } from "../../dataBaseFile/error";
import { btnUpdateProfile, btnUpdateProfileLoading } from "../../dataBaseFile/alert";
import { getRegistereedCompaniesApi } from "../../service/api/user/getRegisteredCompanies";
import SelectStateCompanies from "../../jsx/components/fields/selectStateCompanies";


const ParticularUserDetailsForAdmin = (
  { particularUserDetailsTrigger,
    handleCloseParticularUserDetails, id }
) => {
  const dispatch = useDispatch();
  const { permissionArr,impersonateFlag,rolesUserCanAssign } = useSelector((state) => state.user);
  const permissionArray = permissionArr[0] || []

  // ======================================    Use Effect ========================================

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [userName, setUserName] = useState("");
  const [phonenumber, setPhonenumber] = useState("");

  const [countryCode, setCountryCode] = useState("");
  const [email, setEmail] = useState("");
  const [isFirstNameError, setIsFirstNameError] = useState(false);

  const [avatarArr, setAvatarArr] = useState([]);
  const [avatarId, setAvatarId] = useState();

  const [searchText, setSearchText] = useState("");
  const [roleValue, setRoleValue] = useState(2);



  const [cityName, setCityName] = useState("");
  const [stateName, setStateName] = useState("");
  const [countryName, setCountryName] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [latVal, setLatVal] = useState(0);
  const [longVal, setLongVal] = useState(0);
  const [address, setAddress] = useState("");
  const [placeIdVal, setPlaceIdVal] = useState("");
  const [loaderActive, setLoaderActive] = useState(false)




  const [phonenumberNew, setphonenumberNew] = useState();
  const [countryCodeNew, setCountryCodeNew] = useState();
  const [photoToUpload, setPhotoToUpload] = useState(null);
  const [addressLine1, setAddressLine1] = useState("");
  const [addressLine2, setAddressLine2] = useState("");
  const [profileIcon, setProfileIcon] = useState(false)


  const[companiesList,setCompaniesList] = useState([])
  const[companyId,setCompanyId] = useState("")

  const [roleArr,setRoleArr] = useState([]);








  const setInitialState = (res) => {
    setFirstName(res.data.data.first_name_chr);
    setLastName(res.data.data.last_name_chr);
    setCountryCode(res.data.data.phone_code_id_lng);
    setPhonenumber(res.data.data.phone_number_int);
    setEmail(res.data.data.email_chr);
    setUserName(res.data.data.user_name_chr);
    setAddressLine1(res.data.data.address.address_line_1_chr);
    setAddressLine2(res.data.data.address.address_line_1_chr);
    setAvatarId(res.data.data.avatar_id_lng);
    setZipCode(res.data.data.address.zip_code_int);
    setStateName(res.data.data.address.state_name_chr);
    setCityName(res.data.data.address.city_name_chr);
    setCountryName(res.data.data.address.country_name_chr);
    setLatVal(res.data.data.address.latitude_float);
    setLongVal(res.data.data.address.longitute_float);
    setRoleValue(res.data.data.role_id_int);
    setPlaceIdVal(res.data.data.address.place_id_chr);
    setCountryCodeNew(res.data.data.country_phone_code_chr);
    setAddress(res.data.data.complete_address_chr);
    setProfileIcon(res.data.data.preferred_profile_picture_url)
    setCompanyId(res.data.data.company_id_lng)
    setRoleArr(res.data.data.assign_role_list)
  };

  const handleFirstName = (e) => {
    setIsFirstNameError(false);
    setFirstName(e.target.value);
  };

  const handleLastName = (e) => {
    setLastName(e.target.value);
  };

  useEffect(() => {
    onLoad()
  }, []);


  function onLoad(){
    let details = {
      user_id_ids: id,
       role_id_int:localStorage.getItem("roleId"),
      user_impersonate_flag: 0
    };
    dispatch(
      userById(details, (res) => {
        setAvatarArr(res.data.data.avatar_list);
        setInitialState(res);
     
      })
    );

      
    if(permissionArray.includes("VIEW REGISTERED COMPANIES LIST")){
      let data ={}
dispatch(getRegistereedCompaniesApi(data,(res)=>{
  setCompaniesList(res.data.data)

},(err)=>{}))
    }
  }



  function handleCompaniesSelectValue(e){
    setCompanyId(e.target.value)
  }


  const updateProfile = (e) => {
    e.preventDefault();
    if (firstNameValidation(firstName)) {
      setLoaderActive(true);

      //   const details = {
      //     user_id_ids: id,
      //     first_name_chr: firstName,
      //     last_name_chr: lastName,
      //     phone_code_id_int: countryCode || 0,
      //     phone_number_int: phonenumber || 0,
      //     place_id_chr: placeIdVal || " ",
      //     address_line_1_chr: "",
      //     address_line_2_chr: "",
      //     city_name_chr: cityName || "",
      //     state_name_chr: stateName || "",
      //     country_name_chr: countryName || "",
      //     zip_code_int: zipCode || 0,
      //     longitute_float: longVal | 0.0,
      //     latitude_float: latVal || 0.0,
      //     complete_address_chr:
      //       `${cityName}, ${stateName}, ${zipCode}, ${countryName}` || "",
      //     avatar_id_int: avatarId,
      //     role_id_ids: roleValue,
      //   };
console.log(roleValue,"Role")
      const profileData = new FormData();

      profileData.append("user_id_ids", id);
      profileData.append("first_name_chr", firstName || "");
      profileData.append("last_name_chr", lastName || "");
      profileData.append("phone_code_id_int", +countryCode || 0);
      profileData.append("phone_number_int", +phonenumber || 0);
      profileData.append("place_id_chr", placeIdVal || "");
      profileData.append("address_line_1_chr", addressLine1 || "");
      profileData.append("address_line_2_chr", addressLine2 || "");
      {
        photoToUpload != null
          ? profileData.append("default_image_flag", 1)
          : profileData.append("default_image_flag", 0);
      }
      profileData.append("city_name_chr", cityName || "");
      profileData.append("state_name_chr", stateName || "");
      profileData.append("country_name_chr", countryName || "");
      profileData.append("zip_code_int", zipCode || 0);
      profileData.append("longitute_float", longVal || 0.0);
      profileData.append("latitude_float", latVal || 0.0);
      profileData.append("complete_address_chr", address ? address : "");
      profileData.append("avatar_id_int", avatarId);
      profileData.append("role_id_ids", roleValue);
      profileData.append("company_id_ids",companyId ? companyId : 0)
      {
        photoToUpload != null &&
          profileData.append(
            "profile_picture",
            photoToUpload,
            "profilePhoto.png"
          );
      }

      dispatch(
        updateUserApi(
          profileData,
          (res) => {
            handleCloseParticularUserDetails()
         

            setLoaderActive(false);
          },
          (res) => {


            setLoaderActive(false);



          }
        )
      );
    } else {
      setIsFirstNameError(true);
    }
  };



  function handleRoleValue(e) {

    setRoleValue(e.target.value)

  }



  // Setting International Number format
  useEffect(() => {

    if (phonenumber == null || phonenumber == "") {
      setphonenumberNew("NA");
    } else {
      setphonenumberNew(
        InternationalPhoneFormatFun(`${countryCodeNew}`, `${phonenumber}`)
      );
    }
  }, [phonenumber]);

  return (
    <>
      {/* <!-- Modal --> */}
      <Modal
        className="fade"
        show={particularUserDetailsTrigger}

      >
        <Modal.Header style={{ borderBottom: "none" }}>
          <Modal.Title>{txtUserDetails}</Modal.Title>

          {/* <PrimaryButton
            buttonName={"Close"}
            onClick={handleCloseParticularUserDetails}
          /> */}

          <Button
            variant=""
            className="btn-close btn-close-service"
            onClick={() => handleCloseParticularUserDetails()}
          ></Button>

        </Modal.Header>

        <Modal.Body>
          <form >
            <div className="d-flex align-items-center justify-content-center">
              <div className="image-group-user-for-admin d-flex align-items-center justify-content-center">
                <Avatar src={profileIcon} size="70" alt="" />

                {/* <i class="bi bi-pencil-square"></i> */}
                {/* <img
                  className="edit-profile-icon-user-for-admin"
                  src={filter}
                  alt=""
                /> */}
              </div>
            </div>

            <JoinAsField labelName={txtRole} onChange={handleRoleValue} defaultValue={roleValue}/>
           { roleValue != 2 && <SelectStateCompanies labelName={"Companies"} options={companiesList} onChange={handleCompaniesSelectValue } defaultValue={companyId}/>}

            <InputField
              labelName={lblFirstName}
              placeholderName={lblFirstName}
              onChange={handleFirstName}
              value={firstName}
              errorMeesage={validFirstName}
              errorOccured={isFirstNameError}
              disabled={true}
              onBlur={() => {}}
            />

            <InputField
              labelName={lblLastName}
              placeholderName={lblLastName}
              onChange={handleLastName}
              value={lastName}
              disabled={true}
              onBlur={() => {}}

            />

            <InputField
              labelName={txtUserName}
              placeholderName={txtUserName}

              value={userName}
              disabled={true}
              onBlur={() => {}}

            />

            <InputField
              labelName={lblEmail}
              placeholderName={lblEmail}

              value={email}
              disabled={true}
              onBlur={() => {}}

            />

            <InputField
              labelName={lblPhoneNumber}
              placeholderName={"Enter phone number"}
              value={phonenumberNew}
              disabled={true}
              onBlur={() => {}}
            />

            <SearchAddressInput
              labelName={lblAddress}
              placeholderName={lblAddress}
              value={address}
              disabled={true}
            />
            
<div className="mb-3">
              <label className="mb-1">
                <strong>{"Assinged Role"} </strong>
              </label>
              <div>
               
                 {   rolesUserCanAssign?.map(({role_id_ids,role_name_chr},index)=>(<input
                              type="checkbox"
                              defaultChecked
                              className="form-check-input"
                              id="customCheckBox4"
                              required
                             
                            />))}
                  
             
              </div>
            </div>

            <div className="d-flex align-items-center" style={{ justifyContent: 'flex-end' }}>
              <PrimaryButton buttonName={btnUpdateProfile} onClick={updateProfile} loadingMessage={btnUpdateProfileLoading} isLoading={loaderActive} />
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ParticularUserDetailsForAdmin;
